import React from 'react';
import PropTypes from 'prop-types';
import { DropDownButton } from '@progress/kendo-react-buttons';
import { defaultTemplate } from 'core/hoc';
import { NotifyOutsideClick } from 'core/components';

class HoverDropDownButtonTemplate extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    onItemClick: PropTypes.func,
    children: PropTypes.node,
    text: PropTypes.string,
    buttonClass: PropTypes.string,
    iconClass: PropTypes.string,
    popupSettings: PropTypes.object,
    themeColor: PropTypes.string,
    fillMode: PropTypes.string,
    enableClickToggle: PropTypes.bool,
  };

  state = {
    opened: false,
    openedByClick: false
  };

  handleDocumentClick = () => {
    this.setState({ opened: false, openedByClick: false });
  };

  handleMouseEnter = () => {
    if (!this.props.disabled && !this.state.openedByClick) {
      this.setState({ opened: true, openedByClick: false });
    }
  };

  handleMouseLeave = () => {
    if (!this.state.openedByClick) {
      this.setState({ opened: false, openedByClick: false });
    }
  };

  handleClick = () => {
    if (this.props.disabled || !this.props.enableClickToggle) return;
    const opened = !this.state.openedByClick;
    this.setState({ opened: opened, openedByClick: opened })
  };

  closeDropdown = () => {
    if(this.state.openedByClick) this.setState({ opened: false, openedByClick: false })
  }

  render() {
    const {
      children,
      text,
      buttonClass,
      iconClass,
      popupSettings,
      themeColor,
      fillMode,
      onItemClick,
      disabled
    } = this.props;

    return (
      <NotifyOutsideClick action={() => this.closeDropdown()} ignoreKendoMenus={true}>
        <div
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.handleClick}
        >
          <DropDownButton
            text={text}
            buttonClass={buttonClass}
            iconClass={iconClass}
            popupSettings={popupSettings}
            themeColor={themeColor}
            fillMode={fillMode}
            onItemClick={(e) => {
              const result = typeof onItemClick === 'function' ? onItemClick(e) : null;
              if (result && typeof result.then === 'function') {
                result.then(() => {
                  this.handleDocumentClick();
                });
              } else {
                this.handleDocumentClick();
              }
            }}
            opened={this.state.opened}
            disabled={disabled}
          >
            {children}
          </DropDownButton>
        </div>
      </NotifyOutsideClick>
    );
  }
}

export default defaultTemplate(HoverDropDownButtonTemplate);